<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :apiUrl="apiUrl"
      withoutDelete>

      <template #filter="scope">
        <div class="row">
          <div class="col">
            <b-form-datepicker v-model="logDate" size="sm" locale="id" placeholder="Tanggal" @input="onRefresh" />
          </div>
          <div class="col" v-if="isAdminEmployee">
            <v-select
              v-model="selectedCompanyId"
              :options="listCompanies"
              :reduce="item => item.ID"
              placeholder="Instansi / OPD"
              label="Name"
              @input="onRefresh"/>
          </div>
        </div>
      </template>

      <template #additionalButton="scope" v-if="employeeId === 1405">
        <button
          class="btn btn-sm btn-danger btn-icon-split"
          :disabled="!selectedItem"
          v-b-tooltip.hover
          title="Hapus"
          id="popover-delete">
          <span class="icon">
            <i class="fas fa-trash" />
          </span>
          <span class="text d-none d-lg-inline-block">Hapus</span>
        </button>
        <b-popover target="popover-delete" triggers="focus" placement="top">
          <template v-slot:title>Yakin?</template>
          <button class="btn btn-sm btn-outline-danger" @click="deleteItem">Iya, hapus saja</button>
        </b-popover>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="`${apiUrl}?companyId=${selectedCompanyId}&date=${logDate}`"
      :fields="tableFields"
      :search="search"
      @onSelectItem="selectedItem = $event" />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.onRefresh()

    this.fetchOptionData()
  },
  data() {
    return {
      apiUrl: '/attendance-log',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Employee.NationalIdentityNumber', label: 'NIP' },
        { key: 'Employee', label: 'Nama Pegawai', formatter: value => value.Name },
        { key: 'IpAddress', label: 'Id Perangkat' },
        { key: 'AttendanceUserID', label: 'Id Absensi' },
        { key: 'Capture', label: 'Pukul', formatter: value => this.$helper.formatTime(value) },
        // { key: 'IpAddress', label: 'Alamat Mesin' },
        // { key: 'AttendanceLogStatus', label: 'Status Keharidar', formatter: value => value.Name },
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {},
      scopedDetailData: {},
      logDate: this.$helper.dateToYMD(new Date()),
      listCompanies: [],
      selectedCompanyId: JSON.parse(localStorage.getItem('userData')).employee.CompanyID
    }
  },
  computed: {
    // userCompanyId () {
    //   return this.$store.getters['user/userCompany'].ID
    // },
    isAdminEmployee () {
      return this.$store.state.user.userData.roles.some(item => (item.ID === 5 || item.ID === 4 || item.ID === 7))
    },
    employeeId () {
      return this.$store.state.user.userData?.employee?.ID || 0
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    fetchOptionData () {
      this.$axios.get('/company').then((res) => {
        this.listCompanies = res.data
      })
    },
    deleteItem () {
      this.$root.$emit('bv::hide::popover')
      
      if (!this.selectedItem.ID || !this.apiUrl)
        return

      this.formData = {
        id: this.selectedItem.ID,
        attendanceUserID: this.selectedItem.AttendanceUserID,
        ipAddress: this.selectedItem.IpAddress,
        capture: this.selectedItem.Capture,
      }

      this.$axios.post(`${this.apiUrl}/delete`, this.formData).then(res => {
        this.$emit('refreshTable')

        this.$bvToast.toast('Data berhasil dihapus', {
          title: 'Terhapus!',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          appendToast: true
        })
      })
    },
  }
}
</script>
